<template>
  <div :style="{ width: '75%', marginLeft:'20%', height: '100%'}">
    <v-layout row wrap key="transition">
      <v-flex v-for="user in permissions" :key="user._id" md3 sm6 xs12>
        <v-card color="primary" class="ma-2">
          <v-card-title>
            <h3>{{user.displayName}}</h3>
          </v-card-title>
          <v-divider class="mb-2" />

          <v-card-text v-for="permission in user.permissions" :key="permission._id">
            <v-layout row :style="{marginTop: '-2vh', marginBottom: '-2vh'}">
              <v-flex xs11>
                <h4>{{permission.name}}</h4>
              </v-flex>
              <v-flex xs2 :style="{marginTop: '-2vh'}">
                <v-switch color="success" v-model="permission.permission" hide-details></v-switch>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions class="mt-4">
            <v-btn flat small color="red darken-3" @click="deleteUser(user)">Delete</v-btn>
            <v-spacer />
            <v-btn color="success darken-2" flat small @click="updateUserPermissions(user)">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PermissionsBody",
  computed: {
    ...mapGetters({
      permissions: "settings/getPermissions"
    })
  },

  async mounted() {
    await this.$store.dispatch("settings/getPermissions");
  },

  methods: {
    async deleteUser(user) {
      let confirmText = `Are you sure you want to delete this user from permissions?`;
      if (confirm(confirmText)) {
        await this.$store.dispatch("settings/deleteUserFromPermissions", {
          id: user._id
        });
        this.$store.dispatch("settings/getPermissions");
      }
    },
    updateUserPermissions(user) {
      this.$store.dispatch("settings/updatePermissions", {
        id: user._id,
        body: user
      });
    }
  }
};
</script>

<style>
</style>